module.exports = __webpack_public_path__ + "img/swiper2.62a8ac53.jpg";